import * as React from 'react';
import {connect} from "react-redux";
import {clearOpenWebPage, initializeOpenWebJobData} from "../../data/owp/owpActions";
import {getCompany} from '../../data/jobs/jobActions';
import {owpJobsSelector} from "../../data/owp/owpSelectors";
import {JobListingLayout} from "../static/Layouts";
import OpenWebPromotionForm from './OpenWebPromotionForm';
import Modal from '../static/Modal';
import Header from '../static/Header'
import JobList from '../AgencyPostings/JobList';
import JobDetail from "../AgencyPostings/JobDetail";
import JobSearch from '../AgencyPostings/JobSearch';
import {createCanGetMore, createDidError, createIsLoading} from "../../data/requests/requestsSelectors";
import {
  getOpenWebJobDetails,
  getOpenWebJobs,
  removeOpenWebJob,
} from '../../data/owp/owpActions';

import createLogger from "../../utils/createLogger";
import {Error, Loading} from "../static/Indicators";
const DEBUG = true;
const debug = createLogger(DEBUG, `OpenWebPromotion.js`);

class OpenWebPromotion extends React.Component {

  static dependencies = [
    `GET_OPENWEB_JOBS`,
  ];

  /* -------- lifecycle -------- */
  constructor (props) {
    super (props);
    this.state = {
      selected: null,
      toRemove: null,
      showLoader: true,
      modalIsOpen: false,
      matchUrl: '',
    }
  }

  componentDidMount() {
    const {
      initializeOpenWebJobData,
      isAuthenticated,
    } = this.props;
    debug.enter(`componentDidMount`);
    if (isAuthenticated) {
      debug.log(`  calling initializeOpenWebJobData`);
      initializeOpenWebJobData();
    }
  };

  emptyJobData = () => ({ min_salary: '', max_salary: '', min_experience: '', max_experience: '', contact: '',
                          employment_type: 'Direct Hire', duration: '', hourly_pay: '', posting_date: new Date(),
                          initialized: false});

  /* -------- events -------- */
  select = (id) => this.setState({selected: id});
  deselect = () => this.setState({selected: null});

  clearInputs = () => this.setState({jobData: {...this.emptyJobData()}});

  selectNext = () => {
    const {jobs} = this.props;
    const {findJob, onSelect, clearInputs} = this;
    let i = jobs.findIndex(findJob);
    clearInputs();
    if (jobs.length === 0) {
      this.deselect();
      return
    }
    if (i+1 === jobs.length){
      onSelect(jobs[jobs.length-2]['id'])();
    } else {
      onSelect(jobs[i+1]['id'])();
    }
  };

  selectFirst = () => {
    const {jobs} = this.props;
    const { onSelect, clearInputs} = this;
    clearInputs();
    onSelect(jobs[0]['id'])();
  };

  findJob = (job) => {
    const {selected} = this.state;
    if (job['id'] === selected) {
      return job;
    }
  };

  findCompanyId = (id) => {
    const {jobs} = this.props;
    for (let job of jobs) {
      if (job['id'] === id) {
        return job['company_id']
      }
    }
  };

  onSelect = (id) => () => {
    const {select, deselect, clearInputs, findCompanyId} = this;
    const {selected} = this.state;
    const {getOpenWebJobDetails} = this.props;
    if (id !== selected) {
      clearInputs();
      getOpenWebJobDetails(id);
      select(id);
      getCompany(findCompanyId(id))
    } else {
      clearInputs();
      deselect();
    }
  };

  remove = () => {
    const { selectNext, clearInputs } = this;
    const { removeOpenWebJob, jobs, get } = this.props;
    const {
      selected,
    } = this.state;

    if (!selected) {
      return;
    }

    if (jobs.length > 1){
      selectNext();
    } else {
      this.deselect();
      get();
    }
    console.log(this.state.selected);
    clearInputs();
    removeOpenWebJob(selected);
  };

  removeAll = () => {
    const {jobs, dismissPage} = this.props;
    let ids = [];
    debug.log(jobs);
    for (let job of jobs) {
      ids.push(job['id'])
    }
    debug.log(ids);
    dismissPage(ids);
    this.clearInputs();
    this.deselect();
  };

  selectMatch = (url) => this.setState({matchUrl: url});

  onInputChange = (field) => (input) => {
    console.log(`setting ${field} to ${input}`);
    this.setState({jobData: {...this.state.jobData, [field]: input}});
  };

  selectContact = (contact) => {
    this.setState({jobData: {
        ...this.state.jobData,
        contact: contact,
      }})
  };

  refreshList = () => {
    const {get} = this.props;
    const {deselect} = this;
    deselect();
    get();
  };

  openModal = () => {
    this.setState({
      modalIsOpen: true,
    })
  };

  closeModal = () => {
    this.setState({
      modalIsOpen: false,
    })
  };

  /* -------- rendering -------- */
  render () {
    console.log('in render', this.state, this.props);
    const {
      jobs,
      get,
      dismissPage,
      canGetMore,
      isLoading,
      didError,
      company,
    } = this.props;

    const {
      selected,
      toRemove,
      jobData,
      modalIsOpen,
      matchUrl,
    } = this.state;

    const {
      remove,
      deselect,
      onSelect,
      removeAll,
      onInputChange,
      selectNext,
      refreshList,
      selectContact,
      selectFirst,
      openModal,
      selectMatch,
      closeModal,
    } = this;

    const listConfig = {
      key: `openweb`,
      title: `Open Web Jobs`,
      type: `postings`,
      get,
      dismissPage,
      jobs,
      canGetMore,
      selectFirst,
      isLoading,
      onRemove: remove,
      minimized: !!selected,
      onSelect,
      deselect,
      refreshList,
      selected,
      removeAll,
      owp: true,
    };

    debug.enter('render');

    if (isLoading && jobs.length === 0) {
      return (
          <article className="details">
            <Loading/>
          </article>
      )
    }

    if (didError) {
      return (
        <article>
          <Error message="Error loading jobs"/>
        </article>
      )
    }

    if (!isLoading && jobs.length < 1) {
      return (
        <React.Fragment>
          <Header top/>
          <article className={"details"}>
            <Error message="No open web jobs with google search data found"/>
          </article>
        </React.Fragment>
      )
    }

    return (
      <JobListingLayout>

        <Modal title="Promote Lead"
               className={'full-screen'}
               isOpen={modalIsOpen}
               close={closeModal}
               closeButton>
          <OpenWebPromotionForm closeModal={closeModal} id={selected} matchUrl={matchUrl}
                                selectNext={selectNext} company={company}/>
        </Modal>

        <Header top />

        <JobList {...listConfig}/>

        {
          selected ? (
            <JobDetail id={selected}
                       close={deselect}
                       onRemove={remove}
                       selectContact={selectContact}
                       owp={true}
                       jobData={jobData}
                       onInputChange={onInputChange}/>
          ) : null
        }

        {
          selected
            ? <JobSearch id={selected}
                         selectable={true}
                         openModal={openModal}
                         deselect={deselect}
                         selectMatch={selectMatch}/>
            : null
        }

      </JobListingLayout>
    )
  }
}


const mapStateToProps = (state) => {
  const canGetMore = createCanGetMore(OpenWebPromotion.dependencies[0]);
  const isLoading = createIsLoading(OpenWebPromotion.dependencies);
  const didError = createDidError(OpenWebPromotion.dependencies);

  return {
    isAuthenticated: !!state.auth.session,
    jobs: owpJobsSelector(state),
    canGetMore: canGetMore(state),
    isLoading: isLoading(state),
    didError: didError(state),
    company: state.jobs.company,
  }
};

export default connect(mapStateToProps, {
  get: getOpenWebJobs,
  dismissPage: clearOpenWebPage,
  getOpenWebJobDetails,
  removeOpenWebJob,
  initializeOpenWebJobData,
})(OpenWebPromotion);




// WEBPACK FOOTER //
// ./src/components/OWP/OpenWebPromotion.js